import { component } from '../../../decorators';

import l10n from '../../../transformers/l10n';

@component
export default class BackButton {
   get title() {
      return l10n('back-btn.title');
   }

   back() {
      this.$router.back();
   }
}
